// extracted by mini-css-extract-plugin
module.exports = {"buttonCustom":"style_buttonCustom__XC_WF"};